<template>
  <Modal
    v-model="isModalOpen"
    :append-to-body="true"
    :footer="false"
    :header="false"
    v-if="outcome"
    class="outcome-modal"
    data-test="outcome-modal"
  >
    <template #default>
      <div class="outcome-modal-header text-center">
        <button class="btn-close-sm" @click="closeModal" type="button"></button>
        <img
          :src="outcome.image.url"
          :alt="cms.asText(outcome.name)"
          class="outcome-modal-image"
          data-test="outcome-modal-img"
        />
        <div
          v-html="cms.asHtml(outcome.full_title)"
          class="outcome-full-title"
          data-test="outcome-modal-title"
        ></div>
      </div>
      <div
        v-html="cms.asHtml(outcome.brief_description)"
        class="outcome-desc"
        data-test="outcome-modal-desc"
      ></div>
      <div class="button-container">
        <router-link
          :to="`outcome/${outcomeUid}/select${route.query.asaccredited ? `?asaccredited=${route.query.asaccredited}` : ''}`"
          class="btn btn-primary"
          data-test="outcome-modal-next"
          >Next</router-link
        >
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { Modal } from "uiv";
import { CmsGoalData } from "../../services/cms/cms-type-definitions";
import cms from "../../services/cms/cms";
import { useRoute } from "vue-router";

const props = defineProps<{ outcomeUid: string; outcome: CmsGoalData | null }>();

const isModalOpen = ref(false);
const route = useRoute();

function openModal(): void {
  isModalOpen.value = true;
}

function closeModal(): void {
  isModalOpen.value = false;
}

defineExpose({ openModal, closeModal });
</script>

<style scoped lang="less">
@import (reference) "../../styles/bootstrap/variables";
@modal-left-margin: 20px + @side-nav-collapsed-width;

.outcome-modal-image {
  width: 100%;
  max-width: 350px;
  aspect-ratio: 1 / 1;

  @media (max-width: @screen-sm) {
    max-width: 250px;
  }
  @media (max-width: @screen-xs) {
    max-width: 150px;
  }
}

.btn-close-sm {
  margin-left: auto;
}

.outcome-modal-header {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.button-container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.outcome-desc {
  width: 90%;
  margin: 0 auto;
  text-align: left;
  padding-block: 2rem;
  border-top: 1px solid @light-gray;
}
</style>

<style lang="less">
@import (reference) "../../styles/bootstrap/variables";
.outcome-modal {
  .modal-body {
    padding: 2rem;
  }

  margin-top: 5px;
}

.outcome-full-title {
  h3 {
    margin-top: 0;
    font-weight: normal;
  }

  strong {
    color: inherit;
  }
}
</style>
